module.exports = __webpack_public_path__ + "img/bancontact.e701ebc9.svg";